/**
 * Comprehensive product access — production go-live.
 * Agents buy COMP; underwriting issues COMP for agents / Extend Comprehensive.
 * Super admin tracks issued COMP only (no purchase/issue UI).
 */

export const COMP_PILOT_SUPER_ADMIN_EMAIL = 'dnjatha@monarchinsurance.co.ke';

/** @deprecated Kept for reference only — COMP issue is open to all underwriters. */
export const COMP_PILOT_UNDERWRITER = Object.freeze({
  username: 'CGICHEHA',
  email: 'cgicheha@monarchinsurance.co.ke',
  role: 'underwriting'
});

function norm(v) {
  return String(v || '').trim().toLowerCase();
}

export function staffIdentity(user) {
  return {
    role: norm(user?.role || user?.adminRole),
    email: norm(user?.email),
    username: norm(user?.username)
  };
}

/** Underwriting staff who may issue COMP for agents. */
export function canAccessComprehensiveInternal(user) {
  const { role } = staffIdentity(user);
  return role === 'underwriting';
}

/** Side-nav / overview / Continuations — underwriting only (not super_admin). */
export function canSeeComprehensiveUnderwritingNav(user) {
  const { role } = staffIdentity(user);
  return role === 'underwriting';
}

/** Agents (and underwriters issuing) may purchase COMP. Super admin cannot. */
export function canPurchaseComprehensive(user) {
  if (!user) return true; // agent CoverPurchase often has agent profile
  const { role } = staffIdentity(user);
  if (!role) return true;
  return role === 'agent' || role === 'employee' || role === 'underwriting';
}
